import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import './Instructions.css';

import androidIcon from '/src/assets/img/android.svg';
import iosIcon     from '/src/assets/img/apple.svg';
import windowsIcon from '/src/assets/img/window.svg';
import macosIcon   from '/src/assets/img/macos.svg';
import turn   from '/src/assets/img/turn.png';

const PLATFORMS = [
  { id:'Android', label:'Android', icon: androidIcon, apps:['Happ', 'v2RayTun'] },
  { id:'iOS',     label:'iOS',     icon: iosIcon,     apps:['Happ', 'v2RayTun'] },
  { id:'Windows', label:'Windows', icon: windowsIcon, apps:['v2RayTun'] },
  { id:'macOS',   label:'macOS',   icon: macosIcon,   apps:['v2RayTun'] },
];

const STEPS = {
  Android: [
    <>Скачайте <a target="_blank" href="https://play.google.com/store/apps/details?id=com.happproxy">Happ</a> из Google Play.</>,
    <>Перейдите в раздел <a href="/access">«Доступы»</a> и <b>скопируйте</b> ссылку подписки.</>,
    <>Откройте Happ, нажмите кнопку <b>«Добавить»</b> (или иконку <b>+</b>) и выберите <b>«Add Subscription»</b>.</>,
    <>Вставьте скопированную ссылку в поле URL и нажмите <b>«Save»</b>.</>,
    <>На главном экране Happ нажмите кнопку подключения и подтвердите создание VPN-профиля в системе.</>
  ],
  iOS: [
    <>Скачайте <a target="_blank" href="https://apps.apple.com/ru/app/happ-proxy-utility-plus/id6746188973">Happ</a> из App Store.</>,
    <>В разделе <a href="/access">«Доступы»</a> <b>скопируйте</b> вашу ссылку подписки.</>,
    <>В приложении Happ нажмите <b>+</b> в верхнем углу и выберите <b>«Add Subscription»</b>.</>,
    <>Вставьте ссылку и нажмите <b>«OK»</b>. Профиль подтянется автоматически.</>,
    <>Нажмите на иконку включения <img src={turn} alt="Turn button" style={{width:20, height:20, verticalAlign:'middle'}} /> и разрешите Happ добавить конфигурацию VPN в настройках iPhone.</>
  ],
  Windows: [
    <>Скачайте <a target="_blank" href="https://storage.v2raytun.com/v2RayTun_Setup.exe">v2RayTun</a> для Windows.</>,
    <>На странице <a href="/access">«Доступы»</a> скопируйте ссылку.</>,
    <>В программе нажмите <b>+</b> → <b>Импорт из буфера обмена</b>.</>,
    <>Нажмите на кнопку <img src={turn} alt="Turn button" style={{width:20, height:20, verticalAlign:'middle'}} /> для активации соединения.</>
  ],
  macOS: [
    <>Скачайте <a target="_blank" href="https://apps.apple.com/ru/app/v2raytun/id6476628951">v2RayTun</a> из Mac App Store.</>,
    <>На странице <a href="/access">«Доступы»</a> скопируйте ссылку.</>,
    <>В приложении нажмите <b>+</b> → <b>Импорт из буфера обмена</b>.</>,
    <>Нажмите на кнопку включения <img src={turn} alt="Turn button" style={{width:20, height:20, verticalAlign:'middle'}} />.</>
  ],
};

export default function Instructions(){
  const [tab, setTab] = useState('Android');
  const active = useMemo(() => PLATFORMS.find(p => p.id === tab), [tab]);
  const steps  = STEPS[tab];

  return (
    <>
      <section className="hero">
        <div className="spark"/>
        <div className="access-hero-badge">Помощь</div>
        <h1>Инструкции</h1>
        <div className="sub">Выбери платформу и настрой VPN за 1 минуту</div>
      </section>

      <nav className="ins-tabs" aria-label="Платформы" style={{marginTop:14}}>
        {PLATFORMS.map(p=>(
          <button
            key={p.id}
            className={`ins-tab ${tab === p.id ? 'is-active' : ''}`}
            onClick={() => setTab(p.id)}
            type="button"
            aria-current={tab === p.id ? 'page' : undefined}
          >
            <img className="ins-tab-icon" src={p.icon} alt={p.label}/>
            <span className="ins-tab-label">{p.label}</span>
          </button>
        ))}
      </nav>

      <section className="ins-card" role="region" aria-labelledby="ins-title">
        <div className="ins-grid">
          <aside className="ins-side">
            <div className="ins-platform">
              <div className="ins-platform-icon-wrap">
                <img src={active.icon} alt={active.label} className="ins-platform-icon" />
              </div>
              <div className={'ins-wrap'}>
                <div className="ins-platform-name">{active.label}</div>
                <div className="ins-platform-note">Рекомендуемое приложение</div>
                <ul className="ins-apps">
                  {/* Выводим Happ жирным, остальные просто текстом */}
                  {active.apps.map(a => (<li key={a}><b style={{color: a === 'Happ' ? '#fff' : 'inherit'}}>{a}</b></li>))}
                </ul>
              </div>
            </div>
          </aside>

          <div className="ins-steps-wrap">
            <ol className="ins-steps">
              {steps.map((s,i)=>(
                <li key={i}>
                  <span className="ins-num">{i+1}</span>
                  <span className="ins-step-text">{s}</span>
                </li>
              ))}
            </ol>

            <div className="ins-help">
              Не получается настроить? Напишите нам в поддержку: <a href="https://t.me/altavpn_supp" target="_blank" rel="noreferrer">@altavpn_supp</a>
            </div>
          </div>
        </div>

        <div className="ins-accent" aria-hidden="true" />
      </section>
    </>
  );
}
